export default [
  {
    time: '14:00-14:10',
    title: '主办方开场致辞',
    guests: [
      {
        name: '闻达',
        position: '每日经济新闻董事长、总编辑'
      }
    ]
  },

  {
    time: '14:10-14:25',
    title: '主旨演讲一<br/>促转型 迎创新——全面注册制下投行多元化发展初见格局',
    guests: [
      {
        name: '姜文国',
        position: '国金证券总经理 '
      }
    ]
  },
  {
    time: '14:25-14:40',
    title: '主旨演讲二<br/>券商特色化、专业化发展之路',
    guests: [
      {
        name: '黄海洲 ',
        position: '五矿证券总经理'
      }
    ]
  },

  {
    time: '14:40-14:55',
    title: '主旨演讲三<br/>券商买方财富管理的新时代——基于公募基金投顾业务',
    guests: [
      {
        name: '徐海宁',
        position: '东方证券副总裁'
      }
    ]
  },
  {
    time: '14:55-15:10',
    title: '主旨演讲四<br/>券商财富管理与资管创新升级之路',
    guests: [
      {
        name: '翟晨曦',
        position: '天风证券常务副总裁、恒泰证券联席总裁、新华基金董事长'
      }
    ]
  },
  {
    time: '15:10-15:25',
    title: '主旨演讲五<br/>新时代的财富管理使命——熨平牛熊波动之路',
    guests: [
      {
        name: '方南',
        position: '越秀资产管理有限公司总经理、RO'
      }
    ]
  },
  {
    time: '15:25-15:40',
    title: '每经2021公募基金品牌价值榜发布'
  },
  {
    time: '15:40-16:50',
    title: '圆桌对话<br/>资本市场高质量发展之路',
    guests: [
      {
        name: '主持人 ——'
      },
      {
        name: '李湛',
        position: '招商基金研究部首席经济学家'
      },
      {
        name: '嘉宾 ——'
      },
      {
        name: '朱平',
        position: '广发基金副总经理'
      },
      {
        name: '武怀良',
        position: '开源证券副总裁'
      },
      {
        name: '李立根',
        position: '国海证券总裁助理'
      },
      {
        name: '胡金泉',
        position: '广发证券总裁助理'
      },
      {
        name: '唐  泳',
        position: '华安证券总裁助理兼资产管理总部总经理'
      },
      {
        name: '万健',
        position: '华西证券投行部总经理'
      },
      {
        name: '姚俊',
        position: '招商证券财富管理部总经理'
      }
    ]
  },
  {
    time: '16:50-17:05',
    title: '2021中国上市公司（证券行业）品牌价值榜发布'
  },

  {
    time: '17:05-18:35 ',
    title: '2021中国金鼎奖颁奖典礼',
    subTitle: ' '
  }
];
